import { Grid, IconButton, InputAdornment, InputLabel, useMediaQuery } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import GlobalButton from "../utility/globalButton/button";
import OtpInput from "react18-input-otp";
import { useContext, useEffect, useState } from "react";
import styles from "../../assets/styles/componentStyles/verifyAccount.module.scss";
import { UserContext, UserContextPayload } from "../../context/userContext";
import GlobalTextField from "./globalTextfield";
import globalStyles from "../../assets/styles/global.module.scss"
import { primaryColor } from "../../utils/colors";
import GlobalPopUp from "./globalPopUp";
import OtpReportIssuePopup from "./otpReportIssuePopup";
import agent from "../../services/api";
import { useGenericStore } from "../../store/genericStore";
import { useShallow } from "zustand/react/shallow";
import userProfileStyles from "../../assets/styles/componentStyles/userProfileStyles/userProfileStyle.module.scss";

const VerificationComponent = (props: any) => {
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [invalidOtp, setInvalidOtp] = useState(false);
  const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;

  const { showSuccess, removeErrorSnackbar } = useGenericStore(useShallow((state) => ({
    showSuccess: state.showSuccess,
    removeErrorSnackbar: state.removeErrorSnackbar
  })))

  const [flagReportIssuePopup, setFlagReportIssuePopup] = useState<boolean>(false);
  const [flagIssueReported, setFlagIssueReported] = useState<boolean>(false);

  const breakPoints = {
    flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
  }

  const flagShowPasswordBlock = !!props.flagShowPasswordBlock;

  useEffect(() => {
    if (!flagShowPasswordBlock) {
      props.handleStartTimer();
    }
  }, [])

  const handleKeyDown = async (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.keyCode !== 13) {
      return;
    }
    if (flagShowPasswordBlock) {
      if (password.trim()) {
        (document.getElementById("password") as HTMLInputElement | null)?.blur();
        await props.handleLogin(password);
      }
      return;
    }
    if (otp.length === 6) {
      (document.activeElement as HTMLElement | null)?.blur();
      await props.handleLogin(otp);
    }
  }
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      handleKeyDown(event as any);
    };
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [otp, password, flagShowPasswordBlock]);

  useEffect(() => {
    if (props.flagInvalidOtp) {
      setOtp("")
    }
  }, [props.flagInvalidOtp])

  const handleReportIssue = async () => {
    setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));

    const payload = {
      user_email: props.value, 
      issue: "Not Getting Login Verification Code."
    }

    const res = await agent.reportIssue.post(payload);
    if(res.status){
      setFlagReportIssuePopup(false);
      setFlagIssueReported(true);

      showSuccess("Successfully Reported Issue!")
    } else {
      handleError(res);
    }

    setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
  }

  const handleLoginClick = () => {
    if (flagShowPasswordBlock) {
      props.onClick(password);
    } else {
      props.onClick(otp);
    }
  }

  const isLoginDisabled = flagShowPasswordBlock ? !password.trim() : otp.length < 6;

  return (
    <>
      <Grid
        container
        direction={"column"}
        justifyContent={"space-between"}
      >
        <Grid item>
          <InputLabel className={globalStyles.inputLabel} >Email</InputLabel>
        </Grid>
        <Grid item>
          <GlobalTextField
            fullWidth
            value={props.value}
            sx={{ '& .MuiInputBase-root': { paddingRight: "0px !important" } }}
            onChange={props.onChange}
            disabled={props.disabled}
            InputProps={props.InputProps}
          />
        </Grid>
      </Grid>
      <Grid item className={globalStyles.fullwidth}>
        <Grid
          container
          className={globalStyles.containerFlexWrap}
          justifyContent={"center"}
          alignContent={"center"}
          direction={"column"}
        >
          {flagShowPasswordBlock ? (
            <>
              <Grid item className={`${globalStyles.fullwidth} ${globalStyles.passwordTitleGrid}`}>
                <InputLabel className={globalStyles.inputLabel}>
                  Password
                </InputLabel>
              </Grid>
              <Grid item mb={5} className={globalStyles.fullwidth}>
                <GlobalTextField
                  className={`${globalStyles.globalTextfield} ${styles.passwordTextField}`}
                  margin="normal"
                  required
                  fullWidth
                  id="password"
                  name="password"
                  placeholder="Enter Password"
                  type={showPassword ? "text" : "password"}
                  autoComplete="current-password"
                  autoFocus
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value.replace(/\s/g, ""));
                    removeErrorSnackbar();
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" className={styles.passwordVisibilityAdornment}>
                        <IconButton
                          aria-label={showPassword ? "Hide password" : "Show password"}
                          onClick={() => setShowPassword((prev) => !prev)}
                          edge="end"
                          size="small"
                        >
                          {showPassword ? (
                            <VisibilityOffIcon className={userProfileStyles.passwordVisibilityIcon} />
                          ) : (
                            <VisibilityIcon className={userProfileStyles.passwordVisibilityIcon} />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </>
          ) : (
            <>
              <Grid item className={`${globalStyles.fullwidth} ${globalStyles.verificationCodeGrid}`}>
                Verification Code
                <span className={globalStyles.codeSendtToText}>Sent to {props.value}</span>
              </Grid>
              <Grid item mb={5}>
                <OtpInput
                  value={otp}
                  onChange={(value: any) => {
                    setOtp(value);
                    setInvalidOtp(false);
                  }}
                  isInputNum={true}
                  shouldAutoFocus={true}
                  numInputs={6}
                  inputStyle={
                    invalidOtp ? styles.otpInputError : styles.inputOtpStyle
                  }
                />
              </Grid>
            </>
          )}
          <Grid item className={globalStyles.fullwidth}>
            <GlobalButton
              flagFullWidth
              buttonText="Login"
              disabled={isLoginDisabled}
              className="authButtonStyle"
              onClick={handleLoginClick}
            />
          </Grid>
          {flagShowPasswordBlock ?
            <Grid item mt={1}>
                <a className={`${globalStyles.notGettingLoginCodeText} ${globalStyles.displayFlex} ${globalStyles.justifyCenter}`}>
                  Or<span style={{ color: primaryColor }} onClick={props.handleResendOTP} className={`${globalStyles.clickable} ${globalStyles.resendButtonStyle}`}>
                    login with a verification code
                  </span>
                </a>
            </Grid>
            : 
            <Grid item mt={1}>
              {props.seconds > 0 || props.minutes > 0 ? (
                <>
                  <a
                    className={globalStyles.notGettingLoginCodeText}
                  >
                    {" "}
                    Haven’t received code? Resend code in{" "}
                  </a>
                  <a
                    className={globalStyles.reminingTimeForResendCodeText}
                  >
                    {`${props.minutes}:${props.remainingSeconds < 10 ? "0" : ""
                      }${props.remainingSeconds}`}
                  </a>
                </>
              ) : (
                <>
                  <Grid container direction={"column"} gap={"4px"}>
                    <a
                      className={globalStyles.notGettingLoginCodeText}
                    >
                      {" "}
                      Haven’t received code?<span style={{ color: primaryColor }} onClick={props.handleResendOTP} className={`${globalStyles.clickable} ${globalStyles.resendButtonStyle}`}>Resend</span>
                    </a>
                    {!flagIssueReported && 
                      <a
                        className={globalStyles.notGettingLoginCodeText}
                      >
                        {" "}
                        Still not getting the code?<span style={{ color: primaryColor }} onClick={() => setFlagReportIssuePopup(true)} className={`${globalStyles.clickable} ${globalStyles.resendButtonStyle}`}>Click here</span>
                      </a>
                    }
                  </Grid>
                </>
              )}
            </Grid>
          }
        </Grid>
      </Grid>

      {flagReportIssuePopup && 
        <GlobalPopUp
            open={flagReportIssuePopup}
            onClose={() => { setFlagReportIssuePopup(false); }}
            handleClose={() => { setFlagReportIssuePopup(false); }}
            flagShowCloseIcon={true}
            paperMinWidth={breakPoints.flagSmallScreen ? "300px" : "475px"}
            paperMaxwidth={breakPoints.flagSmallScreen ? "710px" : "575px"}
            borderRadius='10px'
            titlePadding='0px'
            overflow="hidden"
        >
          <OtpReportIssuePopup
            handleReportIssue={handleReportIssue}
          />
        </GlobalPopUp> 
      }
    </>
  );
};

export default VerificationComponent;
